<!--
 * @Author: lijh(¯﹃¯*)
 * @Date: 2023-12-12 09:55:58
 * @LastEditors: lijh(¯﹃¯*)
 * @LastEditTime: 2024-03-06 18:10:43
 * @Description: 三角地详情页
-->
<template>
  <div class="triangle-list">
    <!-- 详情页头部 -->
    <detail-header
      title="三角地"
      icon="icon-a-5Hzhenling"
      :iconStyle="iconStyle"
      :tip="triangleTips"
      @back="back"
    ></detail-header>

    <div class="container-body" v-loading="data.tableLoading">
      <!-- 详情页表单 -->
      <detail-form
        :showNewArticle="true"
        :showPublishButton="true"
        :showReviewButton="deptPower"
        @search="handleClickSearch"
        @showTypeQuery="showTypeQuery"
      ></detail-form>
      <!--   普通用户 标题，申请日期，状态（保存，审核中，审核完成），当前处理人，催办（催办功能是否能实现）-->
      <!--   管理员 标题，申请人，单位，申请日期，状态，操作-->
      <div class="table-card">
        <detail-table
          :data="tableData"
          :columns="tableColumns"
          height="calc(100vh - 380px)"
          :header-cell-style="headerCellStyle"
          :row-style="tableRowClassName"
          :showBorder="false"
          showOperator
          operatorWidth="150"
          @sort-change="sort_change"
        >
          <template #createTm="{scope}">
            <span>{{ scope.row.createTm | dateFormat }}</span>
          </template>
          <template #status="{scope}">
            <span>{{ scope.row.status | computedArticleStatus }}</span>
          </template>

          <template #departmentName="{scope}">
            <span v-if="scope.row.tp == '6'">{{ scope.row.pName }}</span>
            <span v-else>{{ scope.row.departmentName }}</span>
          </template>

          <template #default="{scope}">
            <button
              type="button"
              class="eims-button"
              @click.stop="trianglePrev(scope.row)"
            >
              查看
            </button>

            <button
              type="button"
              v-if="computedShowEdit(scope.row)"
              class="eims-button"
              @click.stop="handleEditTriangle(scope.row)"
            >
              编辑
            </button>
            <button
              type="button"
              v-if="computedShowDelete(scope.row) && scope.row.status !== '1'"
              class="eims-button"
              @click.stop="triangleDelete(scope.row)"
            >
              删除
            </button>
          </template>
        </detail-table>
      </div>
      <div class="page">
        <el-pagination
          layout="sizes, prev, pager, next"
          :total="data.list.length"
          :page-size="data.pageSize"
          :page-sizes="data.pageSizeArray"
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
          :current-page="data.currentPage"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog title="警告" :visible.sync="dialogVisible" width="30%">
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <animation
      :loadingDataVisible="
        !attachmentUploadState || !formInfoSaveState || data.isLoading
      "
      :loadingText="loadingText"
    ></animation>

    <post-create
      :visible.sync="postCreateVisible"
      title="发布三角地文章"
      :tips="triangleTips"
      :baseUrl="baseUrl"
      :showProtocol="true"
      @refresh="queryData"
      @sensitiveWord="sensitiveWord"
    />

    <post-detail
      v-if="postDetailVisible"
      @handlerVisible="handlerVisible"
      :baseUrl="baseUrlDetail"
      :post-code="dialog.postCode"
      :status="dialog.status"
      :tp-code="dialog.postTpCode"
    />

    <post-update
      @sensitiveWord="sensitiveWord"
      v-if="postUpdateVisible"
      @handlerVisible="handlerVisible"
      :baseUrl="baseUrlDetail"
      :baseUrlUpdate="baseUrlUpdate"
      @refresh="queryData"
      :post-code="dialog.postCode"
      :status="dialog.status"
      :post-tp-code="dialog.postTpCode"
    />

    <post-approve
      :row="dialog"
      :visible.sync="postApproveVisible"
      :btnFlag="deptPower"
      @refresh="queryData"
    ></post-approve>
  </div>
</template>

<script>
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import { mapState } from "vuex";
import { Message } from "element-ui";
import { articleMixin } from "../mixins/articleMixin";
import { PAGE_SIZE_ARRAY } from "@/constants/constants";
import animation from "@/components/loading/animation";
import PostCreate from "../../components/detail/PostCreate";
import PostDetail from "../../components/detail/PostDetail";
import PostUpdate from "@/components/detail/PostUpdate";
import PostApprove from "../../components/detail/PostApprove";
import DetailHeader from "@/components/common/DetailHeader";
import DetailForm from "@/components/common/DetailForm";
import DetailTable from "@/components/common/DetailTable";

export default {
  name: "TriangleList",
  components: {
    PostDetail,
    PostCreate,
    animation,
    PostUpdate,
    PostApprove,
    DetailHeader,
    DetailForm,
    DetailTable
  },
  mixins: [articleMixin],
  data() {
    return {
      unApproveMember: false,
      this_: this,
      //搜索的时候显示的列表数据
      searchPublishVisible: false,
      //未审核的 (管理员可以查看的)
      unApprovePublishVisible: false,
      //显示我发布的
      oneSelfPublishVisible: false,
      //默认显示的文章
      allPublishVisible: true,
      //true是结束,false是正在处理
      attachmentUploadState: true,
      //true是结束,false是正在处理
      formInfoSaveState: true,
      loadingText: null,
      data: {
        list: [],
        isLoading: false,
        pageNum: 1,
        pageSize: 10,
        total: 0,
        currentPage: 1,
        pageSizeArray: PAGE_SIZE_ARRAY,
        ARTICLE_DLB_TYPE_CODE: "044-001",
        tableLoading: false,
        sortProp: "createTm",
        sortOrder: "desc"
      },
      form: {
        keyword: "",
        timeRange: []
      },

      queryTimeRange: [],

      dialog: {
        isShow: false,
        postCode: null,
        editFlag: "view",
        postTpCode: "",
        status: ""
      },
      iconStyle: { "font-size": "30px", color: "rgb(18, 217, 226)" },
      dialogVisible: false,
      border: true,
      postCreateVisible: false,
      postDetailVisible: false,
      postUpdateVisible: false,
      postApproveVisible: false,
      //显示文章的类型 -1全部 0我发布的 1待审核的 2搜索的
      showDataType: "-1",
      startPickerOptions: {
        disabledDate: t => {
          return this.form.endTm
            ? t.getTime() > new Date(this.form.endTm).getTime() - 86400000
            : false;
        }
      },
      endPickerOptions: {
        disabledDate: t => {
          return this.form.startTm
            ? t.getTime() < new Date(this.form.startTm).getTime()
            : false;
        }
      },
      //三角地的基础路径
      baseUrl: "/eims-api/triangle/create",
      baseUrlDetail: "/eims-api/triangle/detail",
      baseUrlUpdate: "/eims-api/user/personal/article/update"
    };
  },
  created() {
    this.queryData();
  },
  mounted() {
    this.initPage();
    this.queryData();
  },
  beforeRouteUpdate(to, from, next) {
    next();
    if (to.query.flag) {
      this.showDataType = to.query.flag;
    }
    this.queryData();
  },

  methods: {
    //-1显示全部，0显示自己发布的，1显示未审核的(管理员显示)
    showTypeQuery(type) {
      if (type === "add") {
        this.handleClickAdd();
      } else {
        if (this.showDataType !== type) {
          this.showDataType = type;
          this.data.pageNum = this.$options.data().data.pageNum;
          this.data.list = this.$options.data().data.list;
          this.data.total = this.$options.data().data.total;
          this.$router.push({
            path: this.$route.path,
            query: {
              flag: this.showDataType
            }
          });
        } else {
          this.queryData();
        }
      }
    },
    //新增
    handleClickAdd() {
      this.postCreateVisible = true;
      this.border = false;
      this.dialog.isShow = true;
      this.dialog.editFlag = "add";
    },
    sensitiveWord(items) {
      this.$confirm("存在敏感词汇：" + items)
        .then(_ => {
          items();
        })
        .catch(_ => {});
    },

    handlerVisible(flag) {
      this.postCreateVisible = flag;
      this.postDetailVisible = flag;
      this.postUpdateVisible = flag;
    },

    initPage() {
      if (this.$route.query.flag) {
        this.showDataType = this.$route.query.flag;
      } else {
        this.showDataType = "-1";
      }
      if (this.$route.query.code) {
        this.dialog.postCode = this.$route.query.code;
      }
      let url = window.location.href;
      let index = url.indexOf("flag");
      let code = url.indexOf("code");
      if (index != -1 && code != -1) {
        this.trianglePrevExp();
      }
    },

    //返回
    back() {
      this.$router.push({ path: "/home" });
    },
    closeDialog() {
      this.dialog.isShow = false;
      this.dialog.editFlag = "view";
      this.dialog.postCode = null;
    },
    //查询
    handleClickSearch(form) {
      this.form = { ...this.form, ...form };
      this.data.pageNum = 1;
      this.queryData();
    },
    //分页
    handlePageChange(val) {
      this.data.pageNum = val;
      // this.queryData();
    },

    handleSizeChange(val) {
      this.data.pageSize = val;
      // this.queryData();
    },

    //查看按钮
    trianglePrev(row) {
      if (this.showDataType === "-1") {
        if (row.status == "1") {
          this.baseUrlDetail = "/eims-api/triangle/detail";
          this.postDetailVisible = true;
        } else {
          this.baseUrlDetail = "/eims-api/user/personal/article/detail";
          this.postDetailVisible = true;
        }
      } else if (this.showDataType === "0" || this.showDataType === "2") {
        this.baseUrlDetail = "/eims-api/user/personal/article/detail";
        this.postDetailVisible = true;
      } else if (this.showDataType === "1") {
        this.baseUrlDetail = "/eims-api/share/approve/findById";
        this.postApproveVisible = true;
      }
      this.dialog.editFlag = "view";
      this.border = true;
      this.dialog.isShow = true;
      this.dialog.status = row.status;
      this.dialog.postCode = row.postCode;
    },
    //用作超链接跳转后的查看方法
    trianglePrevExp() {
      if (this.showDataType === "1") {
        this.baseUrlDetail = "/eims-api/share/approve/findById";
        this.postApproveVisible = true;
      }
      this.dialog.editFlag = "view";
      this.border = true;
      this.dialog.isShow = true;
    },
    //删除
    triangleDelete(row) {
      let that = this;
      that
        .$confirm("确定将" + row.postTitle + "删除？", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          if (this.showDataType === "-1") {
            this.deleteTriangleId(row);
          } else if (this.showDataType === "0" || this.showDataType === "2") {
            this.deleteArticle(row);
          } else if (this.showDataType === "1") {
          }
        })
        .catch(() => {});
    },
    deleteArticle(row) {
      let obj = {
        token: cookie.getCookie("token"),
        data: {
          postCode: row.postCode,
          postTpCode: row.postTpCode,
          status: row.status
        }
      };
      http
        .post(
          window.config.api.baseUrl + "/eims-api/user/personal/article/delete",
          obj
        )
        .then(response => {
          if (response.data.code === "00000") {
            Message.success("文章信息删除成功");
          }
        })
        .catch(() => {})
        .finally(() => {
          this.queryData();
        });
    },
    deleteTriangleId(row) {
      let obj = {
        token: cookie.getCookie("token"),
        data: {
          sjdId: row.postCode
        }
      };
      http
        .post(window.config.api.baseUrl + "/eims-api/triangle/delete", obj)
        .then(response => {
          if (response.data.code === "00000") {
            Message.success("三角地文章信息删除成功");
          }
        })
        .finally(() => {
          this.queryData();
        });
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    queryData() {
      //处理时间格式问题
      if (this.form.timeRange) {
        this.queryTimeRange[0] = this.form.startTm
          ? this.moment(this.form.startTm).format("YYYY-MM-DD")
          : null;
        this.queryTimeRange[1] = this.form.endTm
          ? this.moment(this.form.endTm).format("YYYY-MM-DD")
          : null;
        this.startTm = this.form.startTm
          ? this.moment(this.form.startTm).format("YYYY-MM-DD")
          : null;
        this.endTm = this.form.endTm
          ? this.moment(this.form.endTm).format("YYYY-MM-DD")
          : null;
      } else {
        this.queryTimeRange[0] = null;
        this.queryTimeRange[1] = null;
      }

      if (this.showDataType === "-1") {
        if (this.deptPower) {
          this.queryOneself(false);
        } else {
          this.queryAllPublishTriangle();
        }
      } else if (this.showDataType === "0") {
        this.queryOneself(true);
      } else if (this.showDataType === "1") {
        if (this.deptPower) {
          this.queryUnApprove();
        }
      } else if (this.showDataType === "2") {
        this.queryOneself(false);
      }
    },

    //显示全部
    showAllPublishTriangle() {
      if (this.showDataType != "-1") {
        this.showDataType = "-1";
        this.data.pageNum = this.$options.data().data.pageNum;
        this.$router.push({
          path: this.$route.path,
          query: {
            flag: this.showDataType
          }
        });
      } else {
        this.queryData();
      }
    },
    queryAllPublishTriangle() {
      this.data.tableLoading = true;
      http
        .post(window.config.api.baseUrl + "/eims-api/triangle/list", {
          token: cookie.getCookie("token"),
          data: {
            // pageNum: this.data.pageNum,
            // pageSize: this.data.pageSize,
            createUserId: this.userId,
            keyword: this.form.keyword,
            timeRange: this.queryTimeRange,
            // timeRange: [this.form.startTm?this.moment(this.form.startTm).format("YYYY-MM-DD"):null,this.form.endTm?this.moment(_this.form.endTm).format("YYYY-MM-DD"):null],
            startTm: this.startTm,
            endTm: this.endTm,
            showDataType: this.showDataType
            // sortProp: this.data.sortProp,
            // sortOrder: this.data.sortOrder,
          }
        })
        .then(value => {
          if (value.data.code === "00000") {
            this.data.list = value.data.data.articles;
            this.data.total = value.data.data.total;
          }
        })
        .finally(() => {
          this.data.tableLoading = false;
        });
    },

    //显示自己发布的
    showOneselfPublishTriangle() {
      if (this.showDataType != "0") {
        this.showDataType = "0";
        this.data.pageNum = this.$options.data().data.pageNum;
        this.$router.push({
          path: this.$route.path,
          query: {
            flag: this.showDataType
          }
        });
      } else {
        this.queryData();
      }
    },
    //查询自己所有的数据,包括草稿/未审核/审核通过/审核拒绝
    queryOneself(flag) {
      this.data.tableLoading = true;
      let obj = {
        token: cookie.getCookie("token"),
        data: {
          // pageNum: this.data.pageNum,
          // pageSize: this.data.pageSize,
          status: "-1",
          mySelf: flag,
          keyword: this.form.keyword,
          timeRange: this.queryTimeRange,
          startTm: this.startTm,
          endTm: this.endTm,
          postTpCode: this.data.ARTICLE_DLB_TYPE_CODE
          // sortProp: this.data.sortProp,
          // sortOrder: this.data.sortOrder,
        }
      };
      http
        .post(
          window.config.api.baseUrl + "/eims-api/user/personal/article/list",
          obj
        )
        .then(value => {
          if (value.data.code === "00000") {
            this.data.list = value.data.data.approves;
            this.data.total = value.data.data.total;
            this.data.userId = value.data.data.userId;
          }
        })
        .finally(() => {
          this.data.tableLoading = false;
        });
    },

    //显示未审核的(管理员显示)
    showUnApprove() {
      if (this.showDataType != "1") {
        this.showDataType = "1";
        this.data.pageNum = this.$options.data().data.pageNum;
        this.$router.push({
          path: this.$route.path,
          query: {
            flag: this.showDataType
          }
        });
      } else {
        this.queryData();
      }
    },

    //查询未审核的数据
    queryUnApprove() {
      this.data.tableLoading = true;
      let obj = {
        token: cookie.getCookie("token"),
        data: {
          // pageNum: this.data.pageNum,
          // pageSize: this.data.pageSize,
          keyword: this.form.keyword,
          timeRange: this.queryTimeRange,
          status: "0",
          tpCode: this.data.ARTICLE_DLB_TYPE_CODE
          // sortProp: this.data.sortProp,
          // sortOrder: this.data.sortOrder,
        }
      };
      http
        .post(
          window.config.api.baseUrl + "/eims-api/share/approve/findApproveList",
          obj
        )
        .then(value => {
          if (value.data.code === "00000") {
            this.data.list = value.data.data.articles;
            this.data.total = value.data.data.total;
            this.data.userId = value.data.data.userId;
          }
        })
        .finally(() => {
          this.data.tableLoading = false;
        });
    },

    //编辑三角地的信息
    handleEditTriangle(row) {
      if (this.showDataType === "-1") {
        this.baseUrlDetail = "/eims-api/triangle/detail";
      } else if (this.showDataType === "0" || this.showDataType === "2") {
        this.baseUrlDetail = "/eims-api/user/personal/article/detail";
      } else if (this.showDataType === "1") {
        this.baseUrlDetail = "/eims-api/share/approve/findById";
      }
      this.postUpdateVisible = true;
      this.border = false;
      this.dialog.editFlag = "update";
      this.dialog.postCode = row.postCode;
      this.dialog.postTpCode = row.postTpCode;
      this.dialog.status = row.status;
    },

    sort_change(column) {
      this.data.pageNum = 1;
      this.data.sortProp = column.prop;
      this.data.sortOrder = column.order;
      // if (column.order === 'ascending') {
      //   this.data.sortOrder = 'asc'
      // } else if (column.order === 'descending') {
      //   this.data.sortOrder = 'desc'
      // } else {
      //   this.data.sortorder = 'asc'
      // }

      this.data.list = this.data.list.sort((a, b) => {
        if (column.order === "descending") {
          return this.SortString(a[column.prop], b[column.prop], -1);
        } else if (column.order === "ascending") {
          return this.SortString(a[column.prop], b[column.prop], 1);
        }
        return 0;
      });
    },
    SortString(a, b, sortOrder) {
      if (typeof a === "string" && typeof b === "string") {
        return a.localeCompare(b) * sortOrder;
      } else if (typeof a === "number" && typeof b === "number") {
        return (a - b) * sortOrder;
      } else if (a instanceof Date && b instanceof Date) {
        return (a - b) * sortOrder;
      }
    }
  },
  computed: {
    ...mapState({
      deptPower: state => state.userPowerStore.deptPower
    }),
    tableData() {
      return this.data.list.slice(
        (this.data.pageNum - 1) * this.data.pageSize,
        this.data.pageNum * this.data.pageSize
      );
    },
    tableColumns() {
      let arr = [];
      if (this.showDataType === "-1" || this.showDataType === "2") {
        arr = [
          {
            label: "标题",
            prop: "postTitle",
            align: "left",
            width: "auto",
            sortable: true
          },
          {
            label: "发布时间",
            prop: "createTm",
            align: "left",
            width: "200",
            showSlot: true,
            sortable: true
          },
          {
            label: "状态",
            prop: "status",
            align: "left",
            width: "150",
            showSlot: true,
            sortable: true,
            hidden: !this.deptPower
          },
          {
            label: "发布人",
            prop: "userName",
            align: "left",
            width: "150",
            sortable: true
          }
        ];
      } else if (this.showDataType === "0") {
        arr = [
          {
            label: "标题",
            prop: "postTitle",
            align: "left",
            width: "auto",
            sortable: true
          },
          {
            label: "发布时间",
            prop: "createTm",
            align: "left",
            width: "200",
            showSlot: true,
            sortable: true
          },
          {
            label: "状态",
            prop: "status",
            align: "left",
            width: "150",
            showSlot: true,
            sortable: true
          },
          {
            label: "审核人",
            prop: "approveUserName",
            align: "left",
            width: "150",
            sortable: true
          }
        ];
      } else if (this.showDataType === "1") {
        arr = [
          {
            label: "标题",
            prop: "postTitle",
            align: "left",
            width: "auto",
            sortable: true
          },
          {
            label: "发布时间",
            prop: "createTm",
            align: "left",
            width: "200",
            showSlot: true,
            sortable: true
          },
          {
            label: "状态",
            prop: "status",
            align: "left",
            width: "150",
            showSlot: true,
            sortable: true
          },
          {
            label: "申请人",
            prop: "userName",
            align: "left",
            width: "150",
            sortable: true
          },
          {
            label: "单位",
            prop: "departmentName",
            align: "left",
            width: "150",
            showSlot: true,
            sortable: true
          }
        ];
      }
      return arr;
    }
  },
  watch: {
    "data.list.length": {
      handler(newVal, oldVal) {
        if (newVal < oldVal) {
          if (oldVal === 1) {
            if (this.data.pageNum !== 1) {
              this.handlePageChange(this.data.pageNum - 1);
            } else {
              this.handlePageChange(1);
            }
          }
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.triangle-list {
  margin: 20px;
  height: calc(100vh - 109px);
  background-color: #fff;
  box-shadow: 1px 2px 5px #ccc;
  .container-body {
    padding: 10px;
    .table-card {
      margin: 20px 0;
      .eims-button {
        font-size: 16px;
        color: #409eff;
        border-color: transparent;
        background: transparent;
        white-space: nowrap;
        &:focus {
          outline: none;
        }
      }
    }
    .page {
      float: right;
    }
  }
}

/deep/ .el-table .cell {
  line-height: unset;
}
/deep/.el-table--striped
  .el-table__body
  tr.el-table__row--striped
  td.el-table__cell {
  background: #f3fdff;
}
</style>



// WEBPACK FOOTER //
// src/pages/article/TriangleList.vue